export const STANDARDS = {
    SEARCH_LIST: "standards.search",
    GET: "standards.get",
    CLEAR: "standards.clear",
};
